module.exports = __webpack_public_path__ + "img/ngc.d093ce6e.png";